module.exports = __webpack_public_path__ + "static/img/szy.35bb8fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/szy.png
// module id = dKGe
// module chunks = 0